import {
  AuthProvider as AuthProviderBase,
  Session,
  User,
} from "@/shared/session";
import { configFetcher } from "@/shared/core-configs";
import { useState } from "react";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSession, setIsSession] = useState(false);

  const onSession = (session: { session: Session; user: User }) => {
    configFetcher({ authToken: session.session.authToken });
    setIsSession(true);
  };

  return (
    <AuthProviderBase platform="stocks" onSession={onSession}>
      {isSession && children}
    </AuthProviderBase>
  );
};
